export default __webpack_public_path__ + "static/media/kuchnia11.d028e0a0.jpg";